document.addEventListener("DOMContentLoaded", function (): void {
    const form = document.querySelector<HTMLFormElement>("form.search-form");
    const submitBtn = form?.querySelector<HTMLButtonElement>("button.btn--green");

    if (!form || !submitBtn) {
        return;
    }

    form.addEventListener("submit", function (): void {
        submitBtn.classList.add("btn--loading");
        submitBtn.disabled = true;
    });
});
